export const audienceOptions = [
  {
    label: '塔圖受眾包（停止更新）',
    options: [
      { label: '時事關注者', value: 'vm5_01' },
      { label: '白領上班族', value: 'vm5_02' },
      { label: 'Z世代族群', value: 'vm5_03' },
      { label: '3C科技迷', value: 'vm5_04' },
      { label: '健康養生族', value: 'vm5_05' },
      { label: '旅遊愛好者', value: 'vm5_06' },
      { label: '外食打拼族', value: 'vm5_07' },
      { label: '時尚潮流追隨者', value: 'vm5_08' },
      { label: '購物節愛好者', value: 'vm5_09' },
      { label: '運動賽事關注者', value: 'vm5_10' },
      { label: '財經投資者', value: 'vm5_11' },
      { label: '運動愛好者', value: 'vm5_12' },
      { label: '美妝保養愛好者', value: 'vm5_13' },
      { label: '房產關注族群', value: 'vm5_14' },
      { label: '運動服飾愛好者', value: 'vm5_15' },
      { label: '烹飪愛好者', value: 'vm5_16' },
      { label: '閱讀愛好者', value: 'vm5_17' },
      { label: '新手爸媽', value: 'vm5_18' },
      { label: '動漫迷', value: 'vm5_19' },
      { label: '酒類愛好者', value: 'vm5_20' },
      { label: '美食愛好者', value: 'vm5_21' },
      { label: '居家設計愛好者', value: 'vm5_22' },
      { label: '高奢精品愛好者', value: 'vm5_23' },
      { label: '節慶儀式感族', value: 'vm5_24' },
      { label: '汽車愛好族群', value: 'vm5_25' },
      { label: '親子家庭', value: 'vm5_26' },
      { label: '遊戲玩家', value: 'vm5_27' },
      { label: '高端消費族群', value: 'vm5_28' },
      { label: '寵物飼主', value: 'vm5_29' },
      { label: '電影愛好者', value: 'vm5_30' }
    ]
  },
  {
    label: '興趣',
    options: [
      { label: '影視娛樂', value: 'c_001_001' },
      { label: '新聞&教育', value: 'c_001_002' },
      { label: '投資理財', value: 'c_001_003' },
      { label: '居家生活', value: 'c_001_004' },
      { label: '健康', value: 'c_001_005' },
      { label: '運動體育', value: 'c_001_006' },
      { label: '休閒娛樂', value: 'c_001_007' },
      { label: '一般消費', value: 'c_001_008' },
      { label: '美食旅遊', value: 'c_001_009' },
      { label: '交通', value: 'c_001_010' },
      { label: '3C科技', value: 'c_001_011' },
      { label: '房地產', value: 'c_001_012' }
    ]
  },
  {
    label: '生活型態族群',
    options: [
      { label: '高端商務人士', value: 'c_002_001' },
      { label: '孝親族群', value: 'c_002_002' },
      { label: '寵物飼主族群', value: 'c_002_003' },
      { label: '外食打拼族群', value: 'c_002_004' },
      { label: '健康養生族群', value: 'c_002_005' },
      { label: '購物愛好者', value: 'c_002_006' },
      { label: '建築房產關注族群', value: 'c_002_007' },
      { label: '汽車愛好族群', value: 'c_002_008' },
      { label: '母嬰幼兒關注族群', value: 'c_002_009' },
      { label: '速食愛好者', value: 'c_002_010' },
      { label: '白領上班族', value: 'c_002_011' },
      { label: '居家生活族群', value: 'c_002_012' },
      { label: '旅遊關注族群', value: 'c_002_013' },
      { label: '小資族群', value: 'c_002_014' },
      { label: '學生族群', value: 'c_002_015' },
      { label: '理財投資族群', value: 'c_002_016' },
      { label: '時尚美妝達人', value: 'c_002_017' },
      { label: '科技3C族群', value: 'c_002_018' },
      { label: '遊戲玩家族群', value: 'c_002_019' },
      { label: '年輕父母族群', value: 'c_002_020' }
    ]
  },
  {
    label: '下載 APP',
    options: [
      { label: '速食', value: 'c_003_001' },
      { label: '外送平台', value: 'c_003_002' },
      { label: '消費購物', value: 'c_003_003' },
      { label: '交通', value: 'c_003_004' },
      { label: '行動支付', value: 'c_003_005' },
      { label: '汽車', value: 'c_003_006' },
      { label: '房屋與房產', value: 'c_003_007' },
      { label: '旅遊', value: 'c_003_008' },
      { label: '商業財經', value: 'c_003_009' },
      { label: '超商', value: 'c_003_010' },
      { label: '遊戲及動漫', value: 'c_003_011' },
      { label: '電商', value: 'c_003_012' },
      { label: '影音', value: 'c_003_013' },
      { label: '運動', value: 'c_003_014' }
    ]
  },
  {
    label: '近期造訪地點',
    options: [
      { label: '交通運輸', value: 'c_004_001' },
      { label: '社區大樓', value: 'c_004_002' },
      { label: '豪宅', value: 'c_004_003' },
      { label: '休閒娛樂', value: 'c_004_004' },
      { label: '寵物', value: 'c_004_005' },
      { label: '有機商店', value: 'c_004_006' },
      { label: '母嬰用品', value: 'c_004_007' },
      { label: '機車', value: 'c_004_008' },
      { label: '汽車', value: 'c_004_009' },
      { label: '眼鏡店', value: 'c_004_010' },
      { label: '菸酒通路', value: 'c_004_011' },
      { label: '運動用品', value: 'c_004_012' },
      { label: '鞋包配件', value: 'c_004_013' },
      { label: '房地產', value: 'c_004_014' },
      { label: '加油站、充電站', value: 'c_004_015' },
      { label: '月子中心', value: 'c_004_016' },
      { label: '產業園區', value: 'c_004_017' },
      { label: '3C家電', value: 'c_004_018' },
      { label: '便利超商', value: 'c_004_019' },
      { label: '傳統市場', value: 'c_004_020' },
      { label: '居家用品', value: 'c_004_021' },
      { label: '百貨公司', value: 'c_004_022' },
      { label: '藥妝通路', value: 'c_004_023' },
      { label: '購物中心', value: 'c_004_024' },
      { label: '超市', value: 'c_004_025' },
      { label: '量販', value: 'c_004_026' },
      { label: '藝文', value: 'c_004_027' },
      { label: '觀光旅遊', value: 'c_004_028' },
      { label: '運動', value: 'c_004_029' },
      { label: '金融保險', value: 'c_004_030' },
      { label: '身體美容', value: 'c_004_031' },
      { label: '醫療產業', value: 'c_004_032' },
      { label: '餐飲', value: 'c_004_033' }
    ]
  },
  {
    label: '近期瀏覽網頁',
    options: [
      { label: '電子3C', value: 'c_005_001' },
      { label: '運動健身', value: 'c_005_002' },
      { label: '服飾配件', value: 'c_005_003' },
      { label: '鞋類', value: 'c_005_004' },
      { label: '母嬰親子', value: 'c_005_005' },
      { label: '美妝保養', value: 'c_005_006' },
      { label: '居家生活', value: 'c_005_007' },
      { label: '醫療保健', value: 'c_005_008' },
      { label: '時尚精品', value: 'c_005_009' },
      { label: '食品餐飲', value: 'c_005_010' },
      { label: '寵物相關', value: 'c_005_011' },
      { label: '綜合電商', value: 'c_005_012' },
      { label: '進修教育', value: 'c_005_013' },
      { label: '度假旅遊', value: 'c_005_014' },
      { label: '金融保險', value: 'c_005_015' },
      { label: '汽機車', value: 'c_005_016' }
    ]
  },
  {
    label: '收入',
    options: [
      { label: '收入高', value: 'c_006_001' },
      { label: '收入中', value: 'c_006_002' },
      { label: '收入低', value: 'c_006_003' }
    ]
  },
  {
    label: '家庭結構',
    options: [
      { label: '結婚有小孩', value: 'c_007_001' },
      { label: '有養寵物', value: 'c_007_002' }
    ]
  }
];
